import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Observable, Subject, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ProgressReport } from '../../shared/models/progress/progress-report';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  env = environment;
  apiUrl = this.env.apiurl + 'platform/progress-bank-balance-hub';

  private hubConnection: signalR.HubConnection;
  private progressSubject = new Subject<ProgressReport>();

  constructor() {
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(this.apiUrl) // URL to your SignalR hub
      .build();

    this.hubConnection
      .start()
      .then(() => {
        console.log('Connection started!');
        this.hubConnection.on('UpdateNotification', (data: ProgressReport) => {
          this.progressSubject.next(data);
        });
      })
      .catch((err) => {
        throw err;
      });
  }

  getProgress(): Observable<ProgressReport> {
    return this.progressSubject.asObservable();
  }
}
